module.exports = __webpack_public_path__ + "static/media/icon-add.fef9782d.svg";